var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.includes.length
    ? _c(
        "div",
        { staticClass: "preview__section", attrs: { id: "whats-included" } },
        [
          _c("div", { staticClass: "preview__title" }, [
            _vm._v("\n    " + _vm._s(_vm.translations.includes.text) + "\n  "),
          ]),
          _vm.tourIncludes.more
            ? [
                _vm._l(_vm.tourIncludes.start, function (include) {
                  return _c(
                    "div",
                    {
                      key: `include-${include.id}`,
                      staticClass: "preview__include",
                    },
                    [
                      _c("div", {
                        staticClass: "preview__dot preview__dot--green",
                      }),
                      _c("span", { staticClass: "preview__include-text" }, [
                        _vm._v(_vm._s(include.description)),
                      ]),
                    ]
                  )
                }),
                !_vm.showTourIncludes
                  ? _c(
                      "span",
                      {
                        staticClass: "preview__read-more",
                        on: {
                          click: function ($event) {
                            _vm.showTourIncludes = true
                          },
                        },
                      },
                      [_vm._v(_vm._s(_vm.translations.textReadMore.text))]
                    )
                  : _vm._e(),
                _vm.showTourIncludes
                  ? [
                      _vm._l(_vm.tourIncludes.more, function (include) {
                        return _c(
                          "div",
                          {
                            key: `include-${include.id}`,
                            staticClass: "preview__include",
                          },
                          [
                            _c("div", {
                              staticClass: "preview__dot preview__dot--green",
                            }),
                            _c(
                              "span",
                              { staticClass: "preview__include-text" },
                              [_vm._v(_vm._s(include.description))]
                            ),
                          ]
                        )
                      }),
                      _c(
                        "span",
                        {
                          staticClass: "preview__read-more",
                          on: {
                            click: function ($event) {
                              _vm.showTourIncludes = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.translations.textHide.text))]
                      ),
                    ]
                  : _vm._e(),
              ]
            : _vm._l(_vm.tourIncludes, function (include) {
                return _c(
                  "div",
                  {
                    key: `include-${include.id}`,
                    staticClass: "preview__include",
                  },
                  [
                    _c("div", {
                      staticClass: "preview__dot preview__dot--green",
                    }),
                    _c("span", { staticClass: "preview__include-text" }, [
                      _vm._v(_vm._s(include.description)),
                    ]),
                  ]
                )
              }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }